import React, { Component } from 'react';
import { connect } from 'react-redux';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import LinearProgress from 'material-ui/LinearProgress';
import { Route, Switch, Redirect } from 'react-router-dom';
import authGuard from './AuthGuard';
import classnames from 'classnames';

import KiotLoader from '../components/ui/Loader'

import MainApp from 'routes/app/'
import Page404 from 'routes/404/'
import Page403 from 'routes/403/'
import Page500 from 'routes/500/'
import PageConfirmEmail from 'routes/confirm-email/'
import PageForgotPassword from 'routes/forgot-password/'
import PageFullscreen from 'routes/fullscreen/'
import PageLockScreen from 'routes/lock-screen/'
import PageLogin from 'routes/login/'
import PageSignUp from 'routes/sign-up/'

//action
import { AUTHENTICATE_USER } from '../constants/ActionTypes';

//store
import { store } from '../stores/configureStore';

// = styles =
// 3rd
import 'styles/bootstrap.scss';
// custom
import 'styles/layout.scss';
import 'styles/theme.scss';
import 'styles/ui.scss';
import 'styles/app.scss';
import 'assets/css/react-select.css'

import lightTheme from './themes/lightTheme';
import darkTheme from './themes/darkTheme';
import grayTheme from './themes/grayTheme';

//services
import LocalStorageService from '../services/LocalStorageService';
var ls = LocalStorageService;



class App extends Component {

  constructor(props) {
    super(props);
    // Check for token and update application state if required
    const token = ls.getToken();
    this.setPartner();
    if (token) {
      store.dispatch({ type: AUTHENTICATE_USER, auth: true });
    }
    else {
      store.dispatch({ type: AUTHENTICATE_USER, auth: false })
    }


  }

  setPartner(){
    let partner_id = this.getCookie("k_prt");
    ls.setPartner(partner_id);
  }

  getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  componentWillMount() {

  }

  render() {
    const { match, location, layoutBoxed, navCollapsed, navBehind, fixedHeader, sidebarWidth, theme, auth } = this.props;

    let materialUITheme;
    switch (theme) {
      case 'gray':
        materialUITheme = grayTheme;
        break;
      case 'dark':
        materialUITheme = darkTheme;
        break;
      default:
        materialUITheme = lightTheme;
    }

    const isRoot = location.pathname === '/' ? true : false;
    if (isRoot && auth) {
      return (<Redirect to={'/app/dashboard'} />);
    }
    else if (isRoot && !auth) {
      return (<Redirect to={'/login'} />)
    }

    return (
      <MuiThemeProvider muiTheme={getMuiTheme(materialUITheme)}>
        <div id="app-inner">
          <div className="preloaderbar hide"><span className="bar" /></div>
          <div id="dialog-container"></div>
          <KiotLoader />
          <div
            className={classnames('app-main full-height', {
              'fixed-header': fixedHeader,
              'nav-collapsed': navCollapsed,
              'nav-behind': navBehind,
              'layout-boxed': layoutBoxed,
              'theme-gray': theme === 'gray',
              'theme-dark': theme === 'dark',
              'sidebar-sm': sidebarWidth === 'small',
              'sidebar-lg': sidebarWidth === 'large'
            })
            }>

            <Route path={`${match.url}app`} component={authGuard(MainApp)} />
            <Route exact path="/404" component={Page404} />
            <Route exact path="/403" component={Page403} />
            <Route exact path="/500" component={Page500} />
            <Route exact path="/confirm-email" component={PageConfirmEmail} />
            <Route exact path="/forgot-password" component={PageForgotPassword} />
            <Route exact path="/fullscreen" component={PageFullscreen} />
            <Route exact path="/lock-screen" component={PageLockScreen} />
            <Route exact path="/login" component={PageLogin} />
            <Route exact path="/sign-up" component={PageSignUp} />
          </div>
        </div>
      </MuiThemeProvider>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  layoutBoxed: state.settings.layoutBoxed,
  navCollapsed: state.settings.navCollapsed,
  navBehind: state.settings.navBehind,
  fixedHeader: state.settings.fixedHeader,
  sidebarWidth: state.settings.sidebarWidth,
  theme: state.settings.theme,
  auth: state.auth.auth
});

module.exports = connect(
  mapStateToProps
)(App);



// WEBPACK FOOTER //
// ./containers/App.js